import script from "./modalLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./modalLayer.vue?vue&type=script&setup=true&lang=js"

import "./modalLayer.vue?vue&type=style&index=0&id=ba3fc460&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba3fc460"]])

export default __exports__